import React from 'react'

import { AccountMenu } from './account-menu'

export type PrimaryHeaderCTAProps = {
  AccountMenuProps?: React.ComponentProps<typeof AccountMenu>
}

export const PrimaryHeaderCTA: React.FC<PrimaryHeaderCTAProps> = (props) => {
  const { AccountMenuProps } = props

  return <AccountMenu {...AccountMenuProps} />
}

export const PrimaryBodyCTA = null

export const MobilePrimaryHeaderCTA = null

export const MobilePrimaryBodyCTA = null
